/* eslint-disable no-use-before-define */
import './polyfills.js'

import { publish } from './pubsub'
import { isString } from './util'
export * from './ajax'
export {default as atmosphere, processAtmosphereMessage} from './atmosphere'
export * from './back-from'
export * from './compare'
export * from './cookie'
export * from './dash'
export * from './disclosures'
export * from './dom'
export * from './fields'
export * from './format/format'
export * from './frame-in'
export * from './get-config'
export * from './get-id'
export * from './icons'
export * from './icon-label'
export * from './is-cusip'
export * from './is-trading-hour'
export * from './media-queries'
export * from './minimal-navigation'
export * from './paging'
export * from './parse'
export * from './parse-date'
export * from './flyout'
export * from './pubsub'
export * from './section'
export * from './state'
export * from './status'
export * from './track'
export * from './track-search'
export * from './trap-focus'
export * from './url'
export * from './use-previous'
export * from './util'
export * from './values'


const $ = global.$
export {$}


export const getEventHandlers = (dom) => {
    if (!dom) return {}

    for (let key in dom) {
        if (!key.startsWith('__reactEventHandlers$')) continue
        return dom[key]
    }
    return {}
}


export const show = (loc, arg) => {
    let [view, hash] = loc.split('/')
    let a = {view, ...(hash && {hash}), ...arg}
    publish('goto', a)
}

let modalSource = null
let modal2Source = null

export const showModal = (arg) => {
    let p = isString(arg) ? { view:arg } : arg

    let source = p.source || document.activeElement
    let e = $(source)
    if (e.length>0 && !e.is(':focusable')) {
        source = e.closest(':focusable')[0]
    }

    const sourceInModal = $(source).closest('#modal').length > 0 || $(source).closest('#modal2').length > 0
    if (sourceInModal) {
        modal2Source = source
    } else {
        modalSource = source
    }

    publish('modal', {...p, sourceInModal})
}

export const hideModal = () => {
    publish('modal', '')
}

export const returnModalFocus = () => {
    const source = modal2Source || modalSource
    if (!source) return
    try {
        source.focus()
    }
    catch(e) {}
    finally {
        if (modal2Source) {
            modal2Source = null
            return
        }
        modalSource = null
    }
}

export const setScroll = (hash, isHideModal) => {
    try {
        if (isHideModal) hideModal()

        let e = $(hash)
        if (e.length===0) return

        let r = $('#root')
        let t = e.offset().top - r.offset().top

        if (t<=0) return

        r.scrollTop(t)
    } catch(e) {}
}

export const toCamel = (str) => str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, c) => c.toUpperCase())

export const toHash = (str) => (str || '').split('').reduce((a, b) => {
    a = ((a << 5) - a) + b.charCodeAt(0)
    return a & a
}, 0)

export const isWebKit = () => /WebKit/.test(navigator.userAgent)

export const delay = (ms)  => new Promise(ok => setTimeout(ok, ms))

export const safeNum = (x, dv=null) => {
    const n = Number.parseFloat(x)
    return isNaN(n) ? dv : n
}
